//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        //
        // "property_name": "Appleridge Apartments",
        //     "acct": "10ar",
        //     "unit_count": 96,
        //     "address": "2600 Santa Cruz, Office",
        //     "address2": "Odessa, TX 79763",
        //     "phone": "432-335-9263",
        //     "ext": 613,
        //     "fax": "432-332-2851",
        //     "occupancy": 83,
        //     "leased": 94,
        //     "ap": 42379,
        //     "ar": 39264,
        //     "notices": 3,
        //     "insurance":93,
        //     "issues":26,
        //     "residents":742
        return {
            loading: true,
            properties: [],
            arChartData: [[78, 100]],
            totalLeasedUnits: 0,
            totalArDelinquency: 0,
            totalArPrepaid: 0,
            totalOccupancyRented: 0,
            totalUnits: 0,
            bottom: false,
            offset: 0,
            statsLoading: true,
            headers: ['Name', 'Unit count', { title: 'Occupancy %', filter: 'toPercentage' }, 'Leased', 'Month to Month', 'Vacant', { title: 'A/R Delinquent', filter: 'toCurrency' }, { title: 'A/R Prepaid', filter: 'toCurrency' }, { title: 'A/R Balance', filter: 'toCurrency' }],
            fields: ['name', 'kpis.unit_count', 'kpis.occupancy_percent', 'kpis.leased_count', 'kpis.month_to_month_count', 'kpis.vacancy_count', 'kpis.ar_delinquent', 'kpis.ar_prepaid', 'kpis.ar_balance']
        };
    },

    methods: {
        switchProperty: function switchProperty(property) {
            window.location = '/prototype/property/?p=' + property.id;
        },
        add: function add() {
            if (user.role !== 'super-admin') {
                this.$snotify.info('Please contact Help Desk to create a new Property');
            } else {
                Event.$emit('add-new-property');
            }
        },
        refreshData: function refreshData() {
            var _this = this;

            axios.get('/prototype/properties').then(function (response) {
                if (response.data) {
                    _this.properties = response.data.properties.map(function (prop) {
                        prop.kpis.occupancy_percent = parseFloat(prop.kpis.occupancy_percent);
                        prop.kpis.leased_percent = parseFloat(prop.kpis.leased_percent);
                        return prop;
                    });

                    _this.totalLeasedUnits = response.data.stats.leased_unit_count;
                    _this.totalArDelinquency = response.data.stats.ar_delinquent;
                    _this.totalArPrepaid = response.data.stats.ar_prepaid;
                    _this.totalOccupancyRented = response.data.stats.occupancy;
                    _this.totalUnits = response.data.stats.unit_count;
                    _this.statsLoading = false;
                    _this.loading = false;
                }
            });
        }
    },
    mounted: function mounted() {
        this.refreshData();
    },
    created: function created() {
        var _this2 = this;

        Event.$on('property-overview-view-single', function (item, idx) {
            _this2.switchProperty(item);
        });
    },
    destroyed: function destroyed() {
        Event.$off('property-overview-view-single');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/PropertyList.vue
// module id = Bi8t
// module chunks = 0 1